import React, { Component } from 'react';
import CSSModules from 'react-css-modules';

import style from './style.scss';
import EventSummary from '../EventSummary';
import * as eventActions from '../../actions/eventList';
import eventFormatter from '../../services/eventFormatter';

import { connect } from 'react-redux';

import { courseTypeToLabel } from '../../services/courseTypeLabelMapper';

class UpcomingEvents extends Component {

    componentDidMount() {
        this.props.refreshEvents();
    }

    render() {

        return (

            <article className={style['upcoming-events']}>

                <div className={style['section-content']}>

                    <h2 styleName="section-heading--light">Upcoming Events</h2>

                    <div className={style['events-list']}>
                        {this.props.events.map((event, index) => {
                            if(index <= 5) {
                                return (
                                    <EventSummary
                                        className={ style['featured-event'] }
                                        inHouse={ false }
                                        event={event}
                                        moduleHexColour={event.course.module.hex_colour}
                                    >

                                        <span styleName="featured-event__course-type-heading">
                                            { courseTypeToLabel(event.course.type) }
                                        </span>

                                        <span styleName="featured-event__course-name-heading">
                                            {event.course.name}
                                        </span>

                                        {event.multiple_days && (
                                            event.multiple_days_events.map((event_days) => {
                                                return (
                                                    <div>
                                                        <span styleName="featured-event__date">
                                                            {eventFormatter.getFormattedEventDate(event_days)}
                                                        </span>
                                                    </div>
                                                )

                                            })
                                        )}

                                        {!event.multiple_days && (
                                            <span styleName="featured-event__date">{eventFormatter.getFormattedEventDate(event)}</span>
                                        )}

                                        <span styleName="featured-event__venue">{event.venue.address.town_city}</span>

                                    </EventSummary>
                                );
                            }
                        })}
                    </div>
                </div>

            </article>
        );
    }
}

function mapStateToProps(state) {
    return state.eventList;
}

function mapDispatchToProps(dispatch) {
    return {
        refreshEvents() {
            dispatch(eventActions.refreshFeaturedEvents());
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(UpcomingEvents, style));


// WEBPACK FOOTER //
// ./components/UpcomingEvents/index.js